import { createSelector } from 'reselect'
import { selectCurrentUserIsAdminOrOwner } from 'ducks/currentUser/selectors/base'
import { selectHasPendingDowngrade } from '../selectHasPendingDowngrade'
import { selectCurrentInbox } from '../selectCurrentInbox'
import { selectCurrentKb } from '../selectCurrentKb'
import { selectPendingDowngradePlans } from '../selectPendingDowngradePlans'
import { isPlanLimitsExceeded } from '../../util'
import { selectCombinedRemoteLocalUsage } from './selectCombinedRemoteLocalUsage'

export const selectShowBillingPlanUsageLimited = createSelector(
  selectCurrentUserIsAdminOrOwner,
  selectCurrentInbox,
  selectCurrentKb,
  selectCombinedRemoteLocalUsage,
  selectHasPendingDowngrade,
  selectPendingDowngradePlans,
  (
    isManager,
    currentInboxPlan,
    currentKbPlan,
    billingUsage,
    hasPendingDowngrade,
    pendingDowngradePlans
  ) => {
    return (
      hasPendingDowngrade &&
      isManager &&
      (isPlanLimitsExceeded(
        pendingDowngradePlans.inbox || currentInboxPlan,
        billingUsage.inbox
      ) ||
        isPlanLimitsExceeded(
          pendingDowngradePlans.kb || currentKbPlan,
          billingUsage.kb
        ))
    )
  }
)
